
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import api from '@/service/api';

@Component
export default class LogoutScreen extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    value!: boolean;

    redirecting = false;
    spillOrigin = { x: '50%', y: '50%' };

    get spillStyle() {
        return {
            '--spill-x': this.spillOrigin.x,
            '--spill-y': this.spillOrigin.y,
        };
    }

    async redirect(event: MouseEvent) {
        if (this.redirecting) return;
        const button = event.currentTarget as HTMLElement;
        const bounds = button.getBoundingClientRect();
        this.spillOrigin = { x: `${bounds.left + bounds.width / 2}px`, y: `${bounds.top + bounds.height / 2}px` };
        this.redirecting = true;
        sessionStorage.setItem('raws-post-login-url', this.$route.fullPath);
        const transition = new Promise<void>((resolve) => window.setTimeout(resolve, 1100));
        try {
            await Promise.race([api.logout().catch(() => undefined), transition]);
            await transition;
        } finally {
            window.location.href = '/';
        }
    }
}

